<template>
  <div class="ma-4">
    <ClientNav />
    <v-row dense>
      <v-col cols="12">
        <v-overlay :value="isLoading">
          <v-progress-circular
            indeterminate
            color="primary"
          ></v-progress-circular>
        </v-overlay>

        <v-card v-if="!isLoading">
          <v-card-title style="background-color: #2b3990">
            <span class="headline white--text">{{ titleForm }}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="12"
                  md="6"
                  class="text-center"
                  v-if="createMealPlan"
                >
                  <v-menu
                    ref="menu"
                    v-model="menu"
                    :close-on-content-click="false"
                    :return-value.sync="mealDateRange"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-model="mealDateRange"
                        label="Select Date Range"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="mealDateRange"
                      no-title
                      scrollable
                      range
                      @input="handleDateSelection"
                      @change="generateDatePlans"
                    >
                      <v-spacer></v-spacer>
                      <v-btn text color="primary" @click="menu = false">
                        Cancel
                      </v-btn>
                      <v-btn text color="primary" @click="confirmDate">
                        OK
                      </v-btn>
                    </v-date-picker>
                  </v-menu>
                </v-col>

                <v-col cols="12" sm="12" md="6">
                  <v-select
                    :items="units"
                    v-model="newProgram"
                    item-text="Name"
                    item-value="Name"
                    label="Select Program"
                  ></v-select>
                </v-col>

                <v-col cols="12" sm="12">
                  <v-expansion-panels v-for="(range, i) in mealPlans" :key="i">
                    <v-expansion-panel>
                      <v-expansion-panel-header
                        >{{ range.date }}
                      </v-expansion-panel-header>
                      <v-expansion-panel-content>
                        <v-row>
                          <v-col cols="12">
                            <span class="text-body-1 font-weight-bold"
                              >Description</span
                            >
                            <v-alert
                              border="top"
                              colored-border
                              type="info"
                              elevation="2"
                              class="mb-n1 mt-2"
                            >
                            Add Description to ADL Charting
                            </v-alert>
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              label="Description"
                              v-model="range.instructions"
                              outlined
                            ></v-textarea>
                          </v-col>

                          <v-col cols="12">
                            <span class="text-body-1 font-weight-bold"
                              >Breakfast</span
                            >
                            <v-divider />
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              v-model="range.breakfast.time"
                              :items="morningTimes"
                              label="Schedule Time"
                            >
                            </v-select>
                          </v-col>

                          <v-col cols="12">
                            <v-textarea
                              label="Notes"
                              v-model="range.breakfast.notes"
                              outlined
                            ></v-textarea>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <span class="text-body-1 font-weight-bold"
                              >Lunch</span
                            >
                            <v-divider />
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              v-model="range.lunch.time"
                              :items="afternoonTimes"
                              label="Schedule Time"
                            >
                            </v-select>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              label="Notes"
                              v-model="range.lunch.notes"
                              outlined
                            ></v-textarea>
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12">
                            <span class="text-body-1 font-weight-bold"
                              >Dinner</span
                            >
                            <v-divider />
                          </v-col>
                          <v-col cols="12">
                            <v-select
                              v-model="range.dinner.time"
                              :items="eveningTimes"
                              label="Schedule Time"
                            >
                            </v-select>
                          </v-col>
                          <v-col cols="12">
                            <v-textarea
                              label="Notes"
                              v-model="range.dinner.notes"
                              outlined
                            ></v-textarea>
                          </v-col>
                        </v-row>
                      </v-expansion-panel-content>
                    </v-expansion-panel>
                  </v-expansion-panels>
                </v-col>
                <v-col cols="12" sm="12" md="12" v-if="show || updateMealPlan">
                  <v-checkbox
                    label="Signature"
                    @click="addSignature()"
                    v-model="signed"
                  ></v-checkbox>
                  <v-text-field
                    v-if="signed === true"
                    v-model="newCreatedBy"
                    readonly
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              fab
              small
              @click="showPrintModal()"
              class="mr-8 mb-2 white--text"
              color="#2b6993"
              elevation="4"
              v-if="updateMealPlan"
            >
              <v-icon>print</v-icon>
            </v-btn>
            <v-btn
              class="white--text"
              color="#259647"
              @click="addMeal()"
              v-if="createMealPlan && !isAuditorRole"
              >Save
            </v-btn>
            <v-btn
              color="blue darken-1"
              text
              @click="updateMeal()"
              v-if="updateMealPlan && !isAuditorRole"
              >Update
            </v-btn>
            <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
/*eslint-disable*/
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import ClientNav from "@/components/ClientNav.vue";
import moment from "moment";
import {
  displaySuccess,
  displayError,
  displayAlert,
} from "@/service/notification-message.service";
import Swal from "sweetalert2";
import PrintUtil from "../../../../utils/print-util";

const url = require("@/client_config/config").url;

const MORNING = [
  "6:00am",
  "7:00am",
  "8:00am",
  "9:00am",
  "10:00am",
  "11:00am",
  "12:00am",
  "1:00am",
  "2:00am",
  "3:00am",
  "4:00am",
  "5:00am",
];

const AFTERNOON = ["12:00pm", "1:00pm", "2:00pm", "3:00pm", "4:00pm", "5:00pm"];

const EVENING = ["6:00pm", "7:00pm", "8:00pm", "9:00pm", "10:00pm", "11:00pm"];

export default {
  components: {
    ClientNav,
  },
  data: function () {
    return {
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      show: false,
      apply: false,
      msg: "",
      text: "",
      titleForm: "New Weekly Meal Plan",
      search: "",
      isLoading: false,
      meals: [],
      meal: {},
      newStartDate: [],
      newEndDate: "",
      newCreatedBy: "",
      clientID: this.$route.params.clientID,
      mealId: this.$route.params.id,
      userID: localStorage.getItem("userID"),
      token: localStorage.getItem("token"),
      newProgram: "",
      staff: localStorage.getItem("Name"),
      signed: false,
      menu: false,
      clients: [],
      clientList: [],
      units: [],
      createMealPlan: false,
      updateMealPlan: false,
      mealDateRange: [],
      mealPlans: [],
      morningTimes: MORNING,
      afternoonTimes: AFTERNOON,
      eveningTimes: EVENING,
    };
  },

  created() {
    this.createMealPlan = this.$route.query.createMeal === "true";
    this.updateMealPlan = this.$route.query.updateMeal === "true";
    this.getClients();
    this.getPrograms();
  },

  mounted() {
    if (this.updateMealPlan) {
      this.fetch();
    }

    window.addEventListener("keydown", async (event) => {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.handleKeydown(
        event,
        downloadUrl,
        this.mealId,
        this.token,
        "MealPlan"
      );
    });
  },

  beforeDestroy() {
    window.removeEventListener("keydown", (event) => {
      PrintUtil.handleKeydown(
        event,
        this.downloadUrl,
        this.mealId,
        this.token,
        "MealPlan"
      );
    });
  },

  computed: {
    isAuditorRole() {
        return localStorage.getItem("userRole") === 'Auditor'
      }
  },

  methods: {
    ...mapActions({
      createItem: "mealPlans/createItem",
      updateItem: "mealPlans/updateItem",
      getItem: "mealPlans/getItemById",
    }),

    clear() {
      this.mealDateRange = [];
      this.mealsPlan = [];
      this.clientList = [];
      this.newProgram = "";
      this.newCreatedBy = "";
      this.signed = false;
    },

    viewMeal(item) {
      this.titleForm = "Viewing Meal Plan";
      this.mealDateRange = item.MealDateRange;
      this.mealPlans = item.MealPlans;
      this.newCreatedBy = item.SignedBy;
      this.newProgram = item.Program;

      if (item.SignedBy != null) {
        this.newCreatedBy = item.SignedBy;
        this.signed = true;
      } else {
        this.signed = false;
      }
      this.show = true;
      this.apply = true;
    },

    close() {
      this.$router.go(-1);
      this.clear();
    },

    async updateMeal() {
      try {
        const data = {
          MealPlans: this.mealPlans,
          Program: this.newProgram,
          SignedBy: this.newCreatedBy,
        };
        const response = await this.updateItem({
          data,
          id: this.$route.params.id,
        });

        if (response.status === 200) {
          displaySuccess("The meal has been updated successfully.");
          this.$router.push({
            path: `/meals/${this.clientID}/`,
          });
        } else {
          displayError(
            "An error occurred while updating meal. Status: " + response.status
          );
        }
      } catch (error) {
        displayError("An error occurred while updating meal: " + error.message);
      }
    },

    async addMeal() {
      try {
        const data = {
          MealDateRanges: this.mealDateRange,
          MealPlans: this.mealPlans,
          Program: this.newProgram,
          ClientID: this.clientID,
          SignedBy: this.newCreatedBy,
        };
        const response = await this.createItem(data);

        this.createEvents();

        if (response.status === 201) {
          displaySuccess("The meal has been added successfully.");

          this.$router.push({
            path: `/meals/${this.clientID}/`,
          });
        } else {
          displayError(
            "An error has occurred while adding meal. Status: " +
              response.status
          );
        }
      } catch (error) {
        displayError("An error occurred while adding meal: " + error.message);
      }
    },

    async createEvents() {
      const payload = {
        Event: "Menu",
        EventFor: "Client",
        Client: this.clientID,
        Staff: this.userID,
        Program: this.newProgram,
        StartDate: new Date(
          `${this.mealDateRange[0]}T12:00:00.000Z`
        ).toISOString(),
        EndDate: new Date(
          `${this.mealDateRange[1]}T12:00:00.000Z`
        ).toISOString(),
        Notes: "",
        Transportation: "",
        From: "",
        To: "",
        CreatedBy: localStorage.getItem("Name"),
        CreatedDate: new Date(),
        Signature: this.newCreatedBy,
        ReviewingProvider: "",
        VisitType: "",
        UrlNotification: this.$router.history.current.path,
        isRecurringEvent: "No",
        typeOfRecurringEvent: "",
      };

      try {
        const response = await axios.post(`${url}/calendar`, payload);
        console.log(response);
        console.log("Event created successfully:", response.data);
      } catch (err) {
        console.error("Error creating event:", err);
      } finally {
        console.log("Create events operation completed.");
      }
    },

    async fetch() {
      this.isLoading = true;
      try {
        const response = await this.getItem(this.$route.params.id);
        console.log({ response });
        this.viewMeal(response.data);
        this.isLoading = false;
      } catch (error) {
        console.error("Error fetching meals:", error);
      } finally {
        this.isLoading = false;
      }
    },

    async generateDownloadUrl() {
      return `${url}/meals/print-pdf?id=${this.mealId}`;
    },

    async showPrintModal() {
      const downloadUrl = await this.generateDownloadUrl();
      PrintUtil.showPrintOption(
        downloadUrl,
        this.mealId,
        this.token,
        "MealPlan"
      );
    },

    addSignature: function () {
      if (this.newCreatedBy === "") {
        this.newCreatedBy = this.staff + " - " + new Date();
        this.signed = true;
      } else {
        this.signed = false;
        this.newCreatedBy = "";
      }
    },

    getClients() {
      axios.get(`${url}/clients`).then((res) => {
        this.clients = res.data.clients;
      });
    },

    getPrograms() {
      axios.get(`${url}/units`).then((res) => {
        this.units = res.data.units;
      });
    },

    handleDateSelection(value) {
      if (value.length === 1) {
        displayAlert("Start date selected, please select the end date.");
      }
    },

    generateDatePlans() {
      if (this.mealDateRange.length === 2) {
        this.show = true;
        const [startDate, endDate] = this.mealDateRange.map((date) =>
          moment(date)
        );
        const dates = [];

        let currentDate = startDate.clone();
        while (currentDate.isSameOrBefore(endDate, "day")) {
          dates.push(currentDate.clone());
          currentDate.add(1, "days");
        }

        this.mealPlans = dates.map((date) => ({
          date: date.format("dddd, MM-DD-YYYY"),
          instructions: "",
          breakfast: { time: "", notes: "" },
          lunch: { time: "", notes: "" },
          dinner: { time: "", notes: "" },
        }));
      }
    },

    confirmDate() {
      this.$refs.menu.save(this.mealDateRange);
      this.menu = false;
    },
  },
};
</script>
